export default __webpack_public_path__ + "static/media/affiche2010.a8c713c8.png";